import PeriodsNoResults from "./no-results";
import LanesByDay from "./lanes-by-day";
import TitleBar from "./title-bar";
import PeriodCard from "./period-card/";
import BookingLimitedModal from "./booking-limited-modal/";
import PeriodAvailableFromModal from "./period-available-from-modal/";

import HouseCard from "./house-card";
import LaneAccordian from "./lane-accordian/";
import LaneGallery from "./lane-gallery/";
import SearchViewMode from "./view-mode";
import PrioLane from "./lane-prioritized";

const modul = angular
    .module("searchPeriodsComponents", [])
    .controller("bookingLimitedModal", BookingLimitedModal)
    .controller("PeriodAvailableFromModal", PeriodAvailableFromModal)

    .directive("periodsNoResults", PeriodsNoResults)
    .directive("lanesByDay", LanesByDay)
    .directive("prioLane", PrioLane)
    .directive("titleBar", TitleBar)
    .directive("searchViewMode", SearchViewMode)
    .directive("periodCard", PeriodCard)
    .directive("houseCard", HouseCard)
    .directive("laneAccordian", LaneAccordian)
    .directive("laneGallery", LaneGallery);

// .service("searchService", SearchService)
// .factory("searchUrl", searchUrl);

export default modul.name;
